import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { formatPrice } from '../lib/currency';
import { Star, Clock, MapPin, Users } from 'lucide-react';

const LABEL_STYLE = {
  'Best Value': 'bg-accent text-accent-foreground',
  'Top Rated': 'bg-emerald-600 text-white',
  'Most Popular': 'bg-sky-600 text-white',
  "Editor's Choice": 'bg-violet-600 text-white',
  'Best Budget': 'bg-teal-600 text-white',
  'Best for Families': 'bg-amber-600 text-white',
  'Best for Adventure': 'bg-orange-600 text-white',
};

export const TourCard = ({ t, currency = 'INR' }) => (
  <Link to={`/tours/${t.slug}`} className="block h-full" data-testid={`tour-card-${t.slug}`}>
    <Card className="overflow-hidden rounded-2xl card-elevate h-full flex flex-col">
      <div className="aspect-[16/10] bg-secondary overflow-hidden relative">
        {t.images?.[0] && <img src={t.images[0]} alt={t.title} className="w-full h-full object-cover" loading="lazy" />}
        <div className="absolute top-2 left-2 flex flex-col gap-1 items-start">
          {t.sponsored && <Badge className="rounded-full bg-primary/90 text-primary-foreground text-[10px]" data-testid="tour-sponsored-badge">{t.sponsor_label || 'Sponsored'}</Badge>}
          {t.top_label && <Badge className={`rounded-full text-[10px] ${LABEL_STYLE[t.top_label] || 'bg-accent text-accent-foreground'}`} data-testid="tour-top-label">{t.top_label}</Badge>}
        </div>
        {t.is_demo && <Badge variant="outline" className="absolute top-2 right-2 rounded-full bg-amber-500/15 text-amber-700 border-amber-500/30 text-[10px]">DEMO</Badge>}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-1.5 text-[11px] text-muted-foreground mb-1">
          <MapPin className="h-3 w-3" /> {t.country}
          <span className="opacity-40">·</span><Clock className="h-3 w-3" /> {t.duration_days}D/{t.duration_nights}N
          <span className="opacity-40">·</span><span className="capitalize">{t.tour_type}</span>
        </div>
        <p className="font-semibold text-sm leading-snug line-clamp-2 flex-1">{t.title}</p>
        <div className="flex items-center gap-2 mt-2 text-xs">
          <span className="inline-flex items-center gap-0.5 text-amber-600 font-medium"><Star className="h-3.5 w-3.5 fill-amber-500 text-amber-500" /> {t.rating}</span>
          <span className="text-muted-foreground">({t.review_count})</span>
          <Badge variant="outline" className="rounded-full text-[10px] ml-auto"><Users className="h-3 w-3 mr-0.5" />{t.provider_count} partner{t.provider_count === 1 ? '' : 's'}</Badge>
        </div>
        <div className="mt-2 flex items-end justify-between">
          <div>
            <p className="text-[10px] text-muted-foreground">from</p>
            <p className="text-lg font-semibold tabular" data-testid="tour-price">{formatPrice(t.best_price, currency)}</p>
          </div>
          <span className="text-[11px] text-accent font-medium">Compare →</span>
        </div>
      </div>
    </Card>
  </Link>
);
